import React, { VFC } from 'react';

import { useSkippableFragments } from '../hooks/use-skippable-fragments';
import { useCurrentSkippableFragment } from '../../feature-player/hooks/skin/use-current-skippable-fragment';
import { IntroSkipButtonGroupContainer } from '../../feature-player/ui/skin/intro-skip-button-group/container';
import { RecapSkipButtonGroupContainer } from '../../feature-player/ui/skin/recap-skip-button-group/container';
import { CompoundCreditSkipButtonGroupContainer } from '../../feature-player/ui/skin/compound-credit-skip-button-group/container';
import { PrerollSkipButtonGroupContainer } from '../../feature-player/ui/skin/preroll-skip-button-group/container';

interface Props {
    contentId: string;
    className?: string;
}

export const FilmSkipControlsContainer: VFC<Props> = ({ contentId, className }) => {
    const skippableFragments = useSkippableFragments(contentId);
    const currentFragment = useCurrentSkippableFragment(skippableFragments);

    return (
        <>
            <PrerollSkipButtonGroupContainer
                currentFragment={currentFragment}
                className={className}
            />
            <IntroSkipButtonGroupContainer
                contentId={contentId}
                currentFragment={currentFragment}
                className={className}
            />
            <RecapSkipButtonGroupContainer
                currentFragment={currentFragment}
                className={className}
            />
            <CompoundCreditSkipButtonGroupContainer
                currentFragment={currentFragment}
                className={className}
            />
        </>
    );
};
